export type FacebookIconProps = {
    color?: string;
    height?: number;
    width?: number;
};

export const FacebookIcon = ({
    color = "currentColor",
    height = 21,
    width = 11
}: FacebookIconProps) => {
    return (
        <svg
            viewBox="0 0 11 21"
            height={`${height}`}
            width={`${width}`}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m7.14285714 21v-9.5723926h3.23376626l.4935065-3.73619636h-3.72727276v-2.38343558c0-1.19815951.40259741-1.81656442 1.85714286-1.81656442h2v-3.33680981c-.7012987-.10306749-1.67532468-.15460123-2.90909091-.15460123-2.92207792 0-4.83116883 1.80368098-4.83116883 4.93435583v2.75705521h-3.25974026v3.73619636h3.25974026v9.5723926z"
                fill={`${color}`}
            />
        </svg>
    );
};
